import React from "react";
import { Button, Result } from "antd";

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, info) {
		console.error("ErrorBoundary caught an error:", error, info);
	}

	render() {
		if (this.state.hasError) {
			return (
				<Result
					status="error"
					title="Something went wrong"
					subTitle="An unexpected error occurred. Please reload the page and try again."
					extra={
						<Button type="primary" onClick={() => window.location.reload()}>
							Reload Page
						</Button>
					}
				/>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
